export default __webpack_public_path__ + "static/media/26_TopLeftSquares_RotateLeft.af9f647c.mp4";